/**
 * 应用运行组件
 * zxw
 * 创建时间 2026-01-30
 */

import CNF from '../../incs/Config';
import {
    winHeight,
    AddRequestHeaders,
    GetObjValueByPath,
    UjoinParams,
} from '../../incs/FunHelper';
import { SysCall } from '../../incs/SysCall';
import cookie from 'react-cookies';
import { StopIcon } from "../../incs/Icons";
import $ from 'jquery';
import { useState, useEffect, useRef } from 'react';
import {
    Flex,
    theme,
    Button,
    Space,
    Avatar,
    Typography,
    Statistic,
    Badge,
    message,
    Tooltip,
} from 'antd';
import {
    SettingOutlined,
    ContainerOutlined,
    ClearOutlined,
    CaretRightOutlined,
    SyncOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ArrowUpOutlined,
} from '@ant-design/icons';
import {
    Sender,
    Prompts,
    Bubble,
} from '@ant-design/x';
import {
    useXChat,
} from '@ant-design/x-sdk';

// 自定义数据提供
import StepEntity from "./StepEntity";

const { Title, Paragraph, Text } = Typography;


const AppRun = (props) => {
    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorStepBg,
            colorTextBase,
            colorBgSolid,
            colorBasePlaceholder,
            colorSuccessActive,
            colorErrorActive,
            fontSizeLG,
            fontSizeSM,

        },
    } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    const [appInfo, setAppInfo] = useState(null);
    const [appNodeData, setAppNodeData] = useState([]);

    /** AI请求部分 **/
    const contentRef = useRef(null);
    const [runStatus, setRunStatus] = useState(false);
    const [content, setContent] = useState('');         //  用户当前输入内容
    /** AI请求部分 **/

    // 滚动条是否向上滚动
    const isUserScrolledUp = useRef(false);

    // Chat messages
    const { setMessages, abort, messages, isRequesting } = useXChat({});

    // 初始化应用信息
    useEffect(() => {
        const getAppInfo = () => {
            const params = {
                'rss': 'info',
                'app_id': props.appId,
            };
            $.ajax({
                url: `${CNF.api}app/infos${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            })
                .done(function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            const appConfigJson = JSON.parse(data.dat[0].app_config);
                            // 获取节点数据
                            let appNodeData = new Array();
                            for (let i = 0; i < appConfigJson.cells.length; i++) {
                                let node = appConfigJson.cells[i];
                                if (node.shape === 'app-drop-node') {
                                    let obj = node.data;
                                    delete obj.icon;        // 删除图标
                                    delete obj.isSelected;  // 删除选中状态
                                    obj['runTime'] = 0;     // 初始化运行时间，单位毫秒
                                    appNodeData[node.zIndex] = obj;
                                }
                            }
                            setAppNodeData(appNodeData);
                            setAppInfo(data.dat[0]);

                        } else {
                            setAppNodeData(null);
                            setAppInfo(null);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                })
                .fail(function (data) {
                    messageApi.error(data.responseJSON.detail, CNF.messageDuration);
                })
        }
        getAppInfo();
    }, []);

    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        const handleScroll = () => {
            const { scrollTop, scrollHeight, clientHeight } = el;
            // 用户手动向上滚动超过 50px 时，标记为“不在底部”
            isUserScrolledUp.current = scrollHeight - scrollTop - clientHeight > 50;
        };

        el.addEventListener('scroll', handleScroll);
        return () => el.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (!isUserScrolledUp.current && contentRef.current) {
            requestAnimationFrame(() => {
                const el = contentRef.current;
                if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
            });
        }
    }, [messages]);

    /**
     * 获取结果-大模型
     * @param {*} step 
     * @returns 
     */
    const getResultLLM = async (step) => {
        const model = step.model;
        const input = step.input;
        let currentMessages = [];
        if (input?.system_prompt) {
            currentMessages.push({
                role: 'system',
                content: JSON.stringify(input.system_prompt),
            });
        }
        currentMessages.push({
            role: 'user',
            content: JSON.stringify(input.user_prompt),
        });

        return new Promise((resolve, reject) => {
            // 用于存储流式接收到的所有数据块
            let result = '';

            $.ajax({
                url: CNF.onaiApi + 'completions',
                type: 'POST',
                headers: AddRequestHeaders(),
                contentType: 'application/json',
                data: JSON.stringify({
                    project_code: CNF.projectCode.toLocaleLowerCase(),  // 项目代码
                    model: model.name,
                    version_id: model.value,
                    stream: 0,
                    messages: currentMessages,
                    temperature: model.temperature,
                    top_p: model.top_p,
                    max_tokens: model.max_tokens,
                }),
                dataType: 'text', // 关键：必须以文本接收
                processData: false,

                // 核心：监听进度事件以读取流
                xhrFields: {
                    onprogress: function (e) {
                        const responseText = e.target.responseText;
                        // 按行分割
                        const lines = responseText.split('\n');

                        lines.forEach(function (line) {
                            // SSE 数据通常以 "data: " 开头
                            if (line.startsWith('data:')) {
                                var jsonStr = line.substring(5); // 去掉 "data:"

                                // 尝试解析 JSON
                                try {
                                    var jsonData = JSON.parse(jsonStr);
                                    result = jsonData.result;

                                } catch (err) {
                                    console.error("JSON 解析错误:", err);
                                }
                            }
                        });
                    }
                },

                // 当流传输成功结束时触发
                success: function () {
                    resolve(result);
                },

                // 当发生错误时触发
                error: function (xhr, textStatus, errorThrown) {
                    // 注意：SSE 连接断开有时也会触发 error，视浏览器实现而定
                    // 这里我们依然返回已收集的数据，或者根据需求 reject
                    console.error('请求出错:', textStatus);
                    reject('请求火爆请稍后再试！');
                }
            });
        });
    };

    /**
     * 获取结果-MCP
     * @param {*} step 
     * @returns 
     */
    const getResultMCP = async (step) => {
        const input = step.input;
        var params = {
            tool_name: input.toolName,  // 工具名称
        };
        const result = {};
        if (input.parameters && Object.keys(input.parameters).length > 0) {
            for (const key in input.parameters) {
                let content = '';
                // 确保遍历的是对象自身的属性（非原型链上的）
                if (input.parameters.hasOwnProperty(key)) {
                    content = input.parameters[key].default !== undefined ? input.parameters[key].default : '';
                }
                result[key] = content;
            }
        }
        params = {
            ...params,
            arguments: result
        }
        return new Promise((resolve, reject) => {
            // 调用工具

            $.ajax({
                url: `${CNF.xmcpApi}tools`,
                headers: AddRequestHeaders(),
                type: 'POST',
                dataType: 'JSON',
                data: JSON.stringify(params)
            }).done((data) => {
                if (data.res === 0) {
                    resolve(data);
                } else {
                    console.log(CNF.msg);
                    reject(CNF.msg);
                }
            }).fail(() => {
                console.log('MCP服务异常');
                reject('MCP服务异常');
            });
        });
    };

    /**
     * 获取结果-API
     * @param {*} step 
     * @returns 
     */
    const getResultAPI = async (step) => {
        const input = step.input;
        var params = {};
        if (input.params) {
            for (let i = 0; i < input.params.length; i++) {
                const item = input.params[i];
                const key = item.name;
                // 去除为空参数
                // if (item.value === '' || item.value === null) {
                //     continue;
                // }
                params[key] = item.value;
            }
        }

        return new Promise((resolve, reject) => {

            if (input.type && input.type !== 'GET') {
                // 非GET请求
                $.ajax({
                    url: `${input.url}`,
                    headers: AddRequestHeaders(),
                    type: 'POST',
                    dataType: 'JSON',
                    data: JSON.stringify(params)
                }).done(function (data) {
                    if (data.res === 0) {
                        if (input.response?.filed) {
                            resolve(GetObjValueByPath(data, input.response?.filed));
                        } else {
                            resolve(data);
                        }
                    } else {
                        reject(CNF.msg);
                    }
                }).fail(function (data) {
                    reject(data.responseJSON.detail);
                });
            } else {
                $.ajax({
                    url: `${input.url}${Object.keys(params).length === 0 ? '' : UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    type: 'GET',
                }).done((data) => {
                    if (data.res === 0) {
                        if (input.response?.field) {
                            resolve(GetObjValueByPath(data, input.response?.field));
                        } else {
                            resolve(data);
                        }
                    } else {
                        reject(CNF.msg);
                    }
                }).fail((data) => {
                    reject(data.responseText);
                })
            }
        });
    };

    /**
     * 获取结果-变量设置
     * @param {*} step 
     * @returns 
     */
    const getResultVarset = async (nodeList, step) => {
        const variables = step.input?.variables;
        const output = step.output;
        for (const item of variables) {
            if (item.referenceMethod === CNF.referenceMethods[1]) { // 引用
                const parts = item.value.split('/');
                // 判断是否为变量引用
                if (parts.length > 1 && /^([0-9]{1,})$/.test(parts[0])) {
                    // 获取目标节点
                    const targetNode = nodeList[parts[0]]
                    // 引用的变量
                    const content = GetObjValueByPath(targetNode, parts.slice(1).join('/'));
                    output[item.name] = (typeof content === 'string' ? content : JSON.stringify(content));
                }
            } else if (item.referenceMethod === CNF.referenceMethods[2]) {// 系统
                output[item.name] = SysCall[item.value]();
            } else {// 输入
                output[item.name] = item.value;
            }
        }
        return output;
    };

    /**
     * 获取结果-参数提取
     * @param {*} step 
     * @returns 
     */
    const getResultParamex = async (step) => {
        const model = step.model;
        const input = step.input;
        let currentMessages = [];
        if (input?.system_prompt) {
            currentMessages.push({
                role: 'system',
                content: JSON.stringify(input.system_prompt),
            });
        }
        currentMessages.push({
            role: 'user',
            content: JSON.stringify(input.user_prompt),
        });

        return new Promise((resolve, reject) => {
            $.ajax({
                url: CNF.onaiApi + 'completions',
                type: 'POST',
                dataType: 'JSON',
                headers: AddRequestHeaders(),
                data: JSON.stringify({
                    project_code: CNF.projectCode.toLocaleLowerCase(),  // 项目代码
                    model: model.name,
                    version_id: model.value,
                    stream: 0,
                    response_format: 'json_object',
                    messages: currentMessages,
                    temperature: model.temperature,
                    top_p: model.top_p,
                    max_tokens: model.max_tokens,
                })
            }).done((data) => {
                if (data.res === 0) {
                    resolve(data.dat);
                } else {
                    reject('');
                }
            }).fail(() => {
                reject('');
            });
        });
    };

    /**
     * 获取节点输入变量数据
     * 字段如果包含，形如''0/x/x'，即为引用其它节点的变量，则需要转换为对应的内容
     * 第1个数字（如：0）为节点在数组中的位置，之后的字符（如：/x/x）为节点内容路径
     * @param {*} nodeList 
     * @param {*} node 
     */
    const getNodeVarData = (nodeList, node, key = 'input') => {
        const currentNode = node;
        // 获取数组的变量内容
        const getArrVarValue = (arr) => {
            let newArr = arr;
            for (let i = 0; i < arr.length; i++) {
                let arrItem = arr[i];
                if (typeof arrItem === 'string' && arrItem) {
                    // 更新后的值
                    let newValue = '';
                    // 基于分割字符串拆分值
                    let splitArr = arrItem.split(CNF.APP_CONFIG_SPLIT);
                    for (let j = 0; j < splitArr.length; j++) {
                        let splitItem = splitArr[j];
                        let parts = splitItem.split('/');
                        // 判断是否为变量引用
                        if (parts.length > 1 && /^([0-9]{1,})$/.test(parts[0])) {
                            // 获取目标节点
                            let targetNode = nodeList[parts[0]]
                            // 引用的变量
                            const content = GetObjValueByPath(targetNode, parts.slice(1).join('/'));
                            newValue += (typeof content === 'string' ? content : JSON.stringify(content));
                        } else {
                            newValue += splitItem;
                        }
                    }
                    newArr[i] = newValue;
                } else if (Array.isArray(arrItem) && arrItem.length > 0) {
                    newArr[i] = getArrVarValue(arrItem);
                } else if (arrItem && typeof arrItem === 'object' && Object.keys(arrItem).length > 0) {
                    newArr[i] = getObjVarValue(arrItem);
                } else {
                    continue;
                }
            }
            return newArr;
        }

        // 获取对象的变量内容
        const getObjVarValue = (obj) => {
            let newObj = obj;
            // 获取输入对象key数组
            let objKeyArr = Object.keys(obj);
            for (let i = 0; i < objKeyArr.length; i++) {
                // 获取输入对象key对应的值
                let key = objKeyArr[i];
                let value = obj[key];
                // 如果是字符串则解析变量
                if (typeof value === 'string') {
                    // 更新后的值
                    let newValue = '';
                    // 基于分割字符串拆分值
                    let splitArr = value?.split(CNF.APP_CONFIG_SPLIT);
                    for (let j = 0; j < splitArr.length; j++) {
                        let splitItem = splitArr[j];
                        let parts = splitItem.split('/');
                        // 判断是否为变量引用
                        if (parts.length > 1 && /^([0-9]{1,})$/.test(parts[0])) {
                            // 获取目标节点
                            let targetNode = nodeList[parts[0]]
                            // 引用的变量
                            const content = GetObjValueByPath(targetNode, parts.slice(1).join('/'));
                            newValue += (typeof content === 'string' ? content : JSON.stringify(content));
                        } else {
                            newValue += splitItem;
                        }
                    }
                    newObj[key] = newValue;
                } else if (Array.isArray(value) && value.length > 0) {
                    newObj[key] = getArrVarValue(value);
                } else if (value && typeof value === 'object' && Object.keys(value).length > 0) {
                    newObj[key] = getObjVarValue(value);
                } else {
                    continue;
                }
            }
            return newObj;
        }

        if (node[key]) {
            // 获取输入对象key数组
            currentNode[key] = getObjVarValue(node[key]);
        }

        return currentNode;
    }

    /**
     * 获取运行状态
     * @param {*} status 
     * @returns 
     */
    const getRunStatus = (status) => {
        switch (status) {
            case CNF.runStatus.RUNNING:
                return <SyncOutlined spin style={{ color: colorPrimary }} />
            case CNF.runStatus.STOP:
                return <StopIcon style={{ color: colorTextBase, fontSize: fontSizeLG, }} />
            case CNF.runStatus.SUCCESS:
                return <CheckCircleOutlined style={{ color: colorSuccessActive }} />
            case CNF.runStatus.ERROR:
                return <CloseCircleOutlined style={{ color: colorErrorActive }} />
            default:
                return ''
        }
    }

    /**
     * 增加一次调用
     */
    const addOneCall = () => {
        $.ajax({
            url: `${CNF.api}app/infos/${appInfo?.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'add_run_count': 1,
                'description': '运行应用',
            })
        }).done(function (data) {
            if (data.res === 0) {
                //
            } else {
                // 操作失败
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            // 接口异常
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    /**
     * 提交
     * @param {*} content 
     */
    const onSubmit = (content) => {
        // 开始运行，更新运行状态
        setRunStatus(true);

        // 重置运行步骤列表
        const runStepList = [];

        // 将最新的请求添加至末尾
        let newMessages = [...messages];
        if (content) {
            newMessages = [...messages, {
                id: messages.length + 1,
                message: {
                    role: 'user',
                    content: content,
                },
                status: CNF.runStatus.SUCCESS,
            }]
        }
        setMessages(newMessages);

        // 初始步骤：深拷贝“开始”节点，避免污染 appNodeData，写入用户输入
        const startNode = JSON.parse(JSON.stringify(appNodeData[0]));
        startNode.input.sys.query = content;
        runStepList.push(startNode);

        // 创建唯一的运行中 assistant 消息，初始 content 为 [开始节点]
        const assistantMsg = {
            id: newMessages.length + 1,
            message: {
                role: 'assistant',
                content: runStepList, // 初始就包含开始节点
            },
            status: CNF.runStatus.RUNNING,
        };

        newMessages.push(assistantMsg);
        setMessages(newMessages);

        // 开始运行步骤
        // 从 step index = 1 开始执行（开始节点已存在）
        onRunStep(newMessages, runStepList, 1);
    }

    /**
     * 运行步骤
     * @param {*} newMessages 
     * @param {*} runStepList
     * @returns 
     */
    const onRunStep = async (msgs, currentRunStepList, stepIndex) => {
        // 所有步骤执行完毕（stepIndex 等于节点总数）
        if (stepIndex >= appNodeData.length) {
            setMessages(prev => {
                const msgs = [...prev];
                const lastMsg = { ...msgs[msgs.length - 1] };
                lastMsg.message = { ...lastMsg.message, content: currentRunStepList };
                lastMsg.status = CNF.runStatus.SUCCESS;
                msgs[msgs.length - 1] = lastMsg;
                return msgs;
            });
            // 步骤虽然结束了，但是最终输出还在打印中，因此在打印结束后再更新运行状态
            // setRunStatus(false);
            return;
        }

        // 获取下一个步骤定义并深拷贝
        const originalNextStep = appNodeData[stepIndex];
        let nextRunStep = JSON.parse(JSON.stringify(originalNextStep));
        nextRunStep = getNodeVarData(currentRunStepList, nextRunStep);

        // 生成新的步骤列表（包含当前节点）
        const newRunStepList = [...currentRunStepList, nextRunStep];

        // 立即更新消息内容，让界面看到新步骤（runTime 先置 0）
        setMessages(prev => {
            const msgs = [...prev];
            const lastMsg = { ...msgs[msgs.length - 1] };
            lastMsg.message = { ...lastMsg.message, content: newRunStepList };
            msgs[msgs.length - 1] = lastMsg;
            return msgs;
        });

        const start = performance.now();

        try {
            // 执行步骤获取返回数据
            if (nextRunStep.key === CNF.nodeConfig.llm.key) {
                nextRunStep.output.result = await getResultLLM(nextRunStep);
            } else if (nextRunStep.key === CNF.nodeConfig.mcp.key) {
                nextRunStep.output.result = await getResultMCP(nextRunStep);
            } else if (nextRunStep.key === CNF.nodeConfig.api.key) {
                nextRunStep.output.result = await getResultAPI(nextRunStep);
            } else if (nextRunStep.key === CNF.nodeConfig.varset.key) {
                nextRunStep.output = await getResultVarset(newRunStepList, nextRunStep);
            } else if (nextRunStep.key === CNF.nodeConfig.paramex.key) {
                nextRunStep.output = await getResultParamex(nextRunStep);
            } else if (nextRunStep.key === CNF.nodeConfig.end.key) {
                nextRunStep.output.result = getNodeVarData(newRunStepList, nextRunStep, 'output').output?.result;
            }

            // 记录最终耗时
            nextRunStep.runTime = (performance.now() - start).toFixed(0);
            const finalList = [...newRunStepList];
            finalList[finalList.length - 1] = nextRunStep;

            // 更新最终结果
            setMessages(prev => {
                const msgs = [...prev];
                const lastMsg = { ...msgs[msgs.length - 1] };
                lastMsg.message = { ...lastMsg.message, content: finalList };
                msgs[msgs.length - 1] = lastMsg;
                return msgs;
            });

            // 递归执行下一步
            await onRunStep(msgs, finalList, stepIndex + 1);
        } catch (error) {
            // 记录最终耗时
            nextRunStep.runTime = (performance.now() - start).toFixed(0);
            const finalList = [...newRunStepList];
            finalList[finalList.length - 1] = nextRunStep;
            // 异常时清理定时器，并将当前节点标记为错误
            setMessages(prev => {
                const msgs = [...prev];
                const lastMsg = { ...msgs[msgs.length - 1] };
                lastMsg.message = { ...lastMsg.message, content: finalList };
                lastMsg.status = CNF.runStatus.ERROR;
                msgs[msgs.length - 1] = lastMsg;
                return msgs;
            });
            setRunStatus(false);
        }
    }

    return <>
        {/* --start-- 路径栏 */}
        <div style={{
            height: CNF.contentHeaderHeight,
            borderBottom: 'solid 1px',
            borderBottomColor: colorBgSolid,
            padding: `0 ${CNF.basePadding}px`,
        }}>
            {contextHolder}
            <Flex>
                <div style={{ width: '60%', height: CNF.contentHeaderHeight, display: 'flex', alignItems: 'center', }}>
                    <Button
                        color='default'
                        variant='link'
                        style={{ fontSize: fontSizeLG, padding: 0 }}
                        onClick={() => {
                            // 返回上一级
                            props.setUri(props.pUri);
                        }}
                    >{props.menuName}</Button>
                    &nbsp;
                    <Text>/</Text>
                    &nbsp;
                    <Text style={{ fontSize: fontSizeLG, }}><strong>{appInfo?.app_name}</strong></Text>
                </div>
                <div style={{ width: '40%', height: CNF.contentHeaderHeight, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', }}>
                    <Space>
                        <Button
                            color='default'
                            variant='text'
                            size='small'
                            icon={<ContainerOutlined />}
                            onClick={() => {
                            }}
                        >使用指南
                        </Button>
                        <Button
                            color='default'
                            variant='text'
                            size='small'
                            icon={<SettingOutlined />}
                            onClick={() => {
                            }}
                        >设置
                        </Button>
                    </Space>
                </div>
            </Flex>
        </div>
        {/* --end-- 路径栏 */}

        <Flex>
            {/* --start-- 应用运行区 */}
            <div style={{
                height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 9,
                width: '84%',
                borderRight: `1px solid ${colorBgSolid}`,
            }}>
                <Flex vertical={true}>
                    {/* --start-- 快捷操作 */}
                    <div style={{ height: 48, display: 'flex', justifyContent: 'flex-end', padding: CNF.basePadding }}>
                        <Space>
                            <Button
                                color='default'
                                variant='text'
                                size='small'
                                onClick={() => {
                                }}
                            ><Badge dot color={colorPrimary}><SettingOutlined /></Badge>
                            </Button>
                            <Button
                                color='default'
                                variant='text'
                                size='small'
                                onClick={() => {
                                    setMessages([]);
                                }}
                            ><ClearOutlined />
                            </Button>
                        </Space>
                    </div>
                    {/* --end-- 快捷操作 */}

                    {/* --start-- 内容输出 */}
                    <div
                        ref={contentRef}
                        style={{
                            height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 200,
                            scrollbarColor: '#d9d9d9 transparent',
                            scrollbarWidth: 'thin',
                            overflowY: 'auto',
                            padding: '0 20%',
                        }}>
                        {
                            messages.length > 0 ? <>
                                {
                                    messages.map(({ id, message, status }, index) => {
                                        let isLocal = message?.role === 'user' ? true : false;
                                        // 打印用户输入
                                        if (isLocal) {
                                            return <Bubble
                                                key={id}
                                                style={{
                                                    marginBottom: 10,
                                                    marginRight: 10,
                                                    marginTop: index > 0 ? 20 : 0,  // 后续的提示项，添加顶部间距
                                                }}
                                                styles={{
                                                    content: {
                                                        background: colorPrimary,
                                                    }
                                                }}
                                                variant='filled'
                                                placement={'end'}
                                                avatar={(cookie.load(CNF.cookies.keyAvatarUrl) ? <Avatar src={CNF.ossApi + cookie.load(CNF.cookies.keyAvatarUrl)} preview='false' /> : <Avatar style={{ backgroundColor: colorPrimary }}>{cookie.load(CNF.cookies.keyId) ? cookie.load(CNF.cookies.keyId).substr(0, 1).toUpperCase() : 'U'}</Avatar>)}
                                                typing={false}
                                                content={message?.content}
                                                contentRender={(content) => {
                                                    return <Text style={{ color: '#fff' }}>{content}</Text>
                                                }}
                                            />
                                        }

                                        // 打印系统返回
                                        return (
                                            <div key={id}>
                                                {/* 运行状态 */}
                                                <div>
                                                    <Space>
                                                        {
                                                            getRunStatus(status)
                                                        }
                                                        <Text>{status}</Text>
                                                    </Space>
                                                </div>
                                                {/* 运行步骤 */}
                                                <div style={{ background: colorStepBg, marginTop: 12, padding: '3px 0', borderRadius: 8, }}>
                                                    {
                                                        message?.content.map((node, index) => {
                                                            return <StepEntity
                                                                key={index}
                                                                isDarkMode={props.isDarkMode}
                                                                contentRef={contentRef}
                                                                stepIsRunning={(index + 1) === message.content.length && status === CNF.runStatus.RUNNING}
                                                                node={node}
                                                                appInfo={appInfo}
                                                                setRunStatus={setRunStatus}
                                                            />
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </>
                                :
                                <Flex vertical style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {/* 应用图标 */}
                                    <Paragraph><Avatar shape='square' src={appInfo?.app_icon} size={64} style={{ border: `1px solid ${colorBgSolid}` }} /></Paragraph>
                                    {/* 应用标题 */}
                                    <Title level={5} style={{ color: colorTextBase, margin: '10px 0' }}>{appInfo?.app_name}</Title>
                                    {/* 默认提示 */}
                                    <Prompts
                                        vertical
                                        styles={{
                                            item: {
                                                width: '100%',
                                                padding: '8px',
                                                background: colorPrimaryBg,
                                                border: 0,
                                            },
                                        }}
                                        title={<Text style={{ color: colorBasePlaceholder, fontSize: fontSizeSM }}>{appInfo?.prompt_title}</Text>}
                                        items={appInfo?.prompt_examples ? appInfo?.prompt_examples.split('|').map((item, index) => ({
                                            key: index + 1,
                                            icon: <CaretRightOutlined style={{ color: colorPrimary }} />,
                                            description: item,
                                        })) : []}
                                        onItemClick={(info) => {
                                            onSubmit(info.data.description);
                                            addOneCall();
                                        }}
                                    />
                                    {/* 默认提示 */}
                                </Flex>
                        }
                    </div>
                    {/* --end-- 内容输出 */}

                    {/* --start-- 内容输入 */}
                    <div style={{ height: 100, padding: '0 20%', display: 'flex', marginTop: 10, justifyContent: 'center', alignItems: 'center', }}>
                        {
                            // 不需要输入的应用
                            appInfo?.is_input === 0 ? <Tooltip title={runStatus ? '运行中···' : '点击运行'}><Button
                                color='primary'
                                shape='circle'
                                variant={props.isDarkMode ? 'filled' : 'solid'}
                                onClick={() => {
                                    if (runStatus) return; // 运行中禁止取消
                                    onSubmit('');
                                    addOneCall();
                                    setRunStatus(true);
                                }}
                                icon={runStatus ? <SyncOutlined spin /> : <ArrowUpOutlined />}
                            /></Tooltip> : <Sender
                                // 根据运行状态是否为“执行中”判断
                                loading={runStatus}
                                readOnly={runStatus}
                                value={content}
                                autoSize={{ minRows: 3, maxRows: 3 }}
                                style={{ borderColor: colorBgSolid }}
                                suffix={(_, info) => {
                                    const { SendButton, LoadingButton } = info.components;

                                    if (runStatus) {
                                        return (
                                            <Tooltip title='点击取消'>
                                                <LoadingButton />
                                            </Tooltip>
                                        );
                                    }

                                    let node = <SendButton style={{ border: 'none' }} />;

                                    if (!runStatus) {
                                        node = (
                                            <Tooltip title={content ? 'Send \u21B5' : '请输入一些内容'}>{node}</Tooltip>
                                        );
                                    }

                                    return node;
                                }}
                                onChange={nextContent => {
                                    // 输入内容改变
                                    setContent(nextContent)
                                }}
                                onSubmit={(nextContent) => {
                                    // 发送指令请求
                                    onSubmit(nextContent);
                                    setContent('');
                                    addOneCall();
                                }}
                                onCancel={() => {
                                    // 取消指令请求
                                    // setMessages([...messages.slice(0, -1), { ...messages[messages.length - 1], status: CNF.runStatus.STOP }]);
                                    setMessages((messages.at(-1).status = CNF.runStatus.STOP, messages))
                                    setRunStatus(false);
                                    try {
                                        abort();
                                    } catch {
                                        //
                                    }
                                }}
                            />
                        }

                    </div>
                    {/* --end-- 内容输入 */}

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '8px 0' }}>
                        <Text style={{ color: colorBasePlaceholder, fontSize: fontSizeSM, }}>内容由AI生成，仅供参考</Text>
                    </div>
                </Flex>
            </div>
            {/* --end-- 应用运行区 */}

            {/* --start-- 应用展示区 */}
            <div style={{
                height: winHeight - CNF.menuHeight - CNF.contentHeaderHeight - 9,
                width: '16%',
                padding: CNF.basePadding,
            }}>
                {/* 应用图标 */}
                <Paragraph style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}><Avatar shape='square' src={appInfo?.app_icon} size={48} style={{ border: `1px solid ${colorBgSolid}` }} /></Paragraph>
                {/* 应用标题 */}
                <Title level={4} style={{ display: 'flex', justifyContent: 'center', color: colorTextBase, margin: '10px 0' }}>{appInfo?.app_name}</Title>
                {/* 应用描述 */}
                <Paragraph style={{ color: colorBasePlaceholder, fontSize: fontSizeSM }}>{appInfo?.app_description}</Paragraph>
                {/* 应用使用 */}
                <Paragraph style={{ color: colorTextBase, fontSize: fontSizeLG, margin: 0 }}><Statistic suffix={appInfo?.run_count >= 10000 ? '万' : ''} value={appInfo?.run_count >= 10000 ? (appInfo?.run_count / 10000).toFixed(CNF.DPL) : appInfo?.run_count} /></Paragraph>
                <Paragraph style={{ color: colorBasePlaceholder, fontSize: fontSizeSM }}>使用次数</Paragraph>
            </div>
            {/* --end-- 应用展示区 */}
        </Flex>
    </>
}

export default AppRun;